import React from 'react'
import styled from 'styled-components'
import { TextAlignment } from '@modules/common/models/enums'
import { StyledTypographyComponent } from '../AverageDepth/AvgDepthTextFieldList'
import Tooltip from '@material-ui/core/Tooltip'

interface IProps {
  alignment?: TextAlignment
  fontSize?: string
  cellPadding?: string
  value?: string
  onClick?: any
  cursor?: string
  verticalAlign?: string
  disabled?: boolean
  width?: number
}

const Root = styled.div<IProps>((props: any) => {
  return {
    height: '100%',
    padding: props.cellPadding ? props.cellPadding : 'var(--cell-padding)',
    display: 'flex',
    alignItems: props.verticalAlign ? props.verticalAlign : 'center',
    cursor: props.cursor ? props.cursor : null,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    ...(props.disabled ? { opacity: 0.5 } : null)
  }
})

export const Label: React.FunctionComponent<IProps> = React.memo((props: IProps) => {
  const {
    alignment,
    value,
    cellPadding,
    fontSize,
    onClick,
    cursor,
    verticalAlign,
    disabled,
    width
  } = props
  return (
    <Root
      cellPadding={cellPadding}
      cursor={cursor}
      onClick={onClick}
      verticalAlign={verticalAlign}
      disabled={disabled}
    >
      <StyledTypographyComponent font={fontSize} alignment={alignment} width={width}>
        <Tooltip title={value}>
          <span>{value}</span>
        </Tooltip>
      </StyledTypographyComponent>
    </Root>
  )
})
